import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import overlayFactory from "react-bootstrap-table2-overlay";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import { useTranslation } from "react-i18next";
import { getNotifications } from "../../../api/clinicalTrial";
import Card from "../../../components/Cards/Card";
import { Next } from "../../../components/Icons/Icons";
import { Tooltip } from "../../../components/Utils/Tooltips";
import { ModalNotificationsEvents } from "./ModalNotificationsEvents";
import { NotificationsUsers } from "./NotificationUsers";

export const NotificationEvents = ({ startup, expandedAll, onStateChange }) => {
  const { t } = useTranslation();
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [notificationStates, setNotificationStates] = useState({});
  const [data, setData] = useState([]);

  useEffect(() => {
    if (onStateChange && Object.keys(notificationStates).length > 0) {
      onStateChange(notificationStates);
    }
  }, [notificationStates]);

  useEffect(() => {
    const fetchData = async () => {
      const result = await getNotifications(startup.id);

      if (result.status === 200 && startup?.protocol?.protocolPractitioners) {
        const configs = result.data.configs;
        const notifications = result.data.notifications;

        const initialState = {};

        notifications.forEach((event) => {
          initialState[event.id] = {};

          startup.protocol.protocolPractitioners.forEach((pract) => {
            const configMatch = configs.find(
              (cfg) =>
                parseInt(cfg.eventId) === event.id &&
                cfg.practitionerId === pract.practitionerUserId
            );

            initialState[event.id][pract.practitionerUserId] = {
              email: !!configMatch?.email,
              sms: !!configMatch?.sms,
              whatsapp: !!configMatch?.whatsapp,
            };
          });
        });

        setData(notifications);
        setNotificationStates(initialState);
      }
    };

    fetchData();
  }, [startup]);

  const expandedContent = (row) => (
    <NotificationsUsers
      startup={startup}
      notificationState={notificationStates[row.id] || {}}
      onChange={(practitionerUserId, channel, value) =>
        handleNotificationChange(row.id, practitionerUserId, channel, value)
      }
    />
  );

  const handleNotificationChange = (
    eventId,
    practitionerUserId,
    channel,
    value
  ) => {
    setNotificationStates((prev) => ({
      ...prev,
      [eventId]: {
        ...(prev[eventId] || {}),
        [practitionerUserId]: {
          ...(prev[eventId]?.[practitionerUserId] || {}),
          [channel]: value,
        },
      },
    }));
  };

  const columns = [
    {
      dataField: "module",
      text: t("clinicalTrials.notifications.module"),
      headerStyle: { width: "100px" },
    },
    {
      dataField: "events",
      text: t("clinicalTrials.notifications.event"),
      headerStyle: { width: "100px" },
    },
    {
      dataField: "view",
      text: "",
      isDummyField: true,
      headerClasses: "header-protocol-actions",
      classes: "row-protocol-actions",
      headerStyle: { width: "100px" },
      headerAlign: "center",
      align: "center",
      formatter: (_cell, row, rowIndex) => (
        <div key={rowIndex}>
          <Tooltip
            tooltip={t("clinicalTrials.notifications.viewMore")}
            id={`tooltipvisit-${row.id}`}
          >
            <button
              className="btn-table-actions"
              onClick={() => {
                setSelectedEvent(row);
                setShowModal(true);
              }}
            >
              <Next />
            </button>
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <>
      <Card
        content={
          <BootstrapTable
            bordered={false}
            hover
            remote
            keyField="id"
            data={data}
            columns={columns}
            classes="table-spaced table-spaced-small"
            wrapperClasses="table-responsive"
            noDataIndication={() => <>{t("commons.noData")}</>}
            overlay={overlayFactory({ spinner: true })}
            expandRow={{
              renderer: expandedContent,
              onlyOneExpanding: true,
            }}
          />
        }
      />

      <ModalNotificationsEvents
        show={showModal}
        onClose={() => setShowModal(false)}
        notificationEvent={selectedEvent}
      />
    </>
  );
};
